import { render } from "./banner-dashboard.vue?vue&type=template&id=63292558&ts=true"
import script from "./banner-dashboard.vue?vue&type=script&lang=ts"
export * from "./banner-dashboard.vue?vue&type=script&lang=ts"

import "./banner-dashboard.vue?vue&type=style&index=0&id=63292558&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__